module.exports = __webpack_public_path__ + "static/media/2.0bb4e86c.svg";